import axios from "axios";
import { backend_url } from "../../constants";
import { AXIOS_CONFIG } from "../api";

const API_URL = `${backend_url}/api/analytics/taxpro`;

interface AnalyticsParams {
  tax_year?: number | null;
}

export const getTaxProAnalytics = async (params?: AnalyticsParams) => {
  try {
    // Only include tax_year if it has a value
    const cleanParams: Record<string, any> = {};
    if (params?.tax_year !== undefined && params?.tax_year !== null) {
      cleanParams.tax_year = params.tax_year;
    }

    const response = await axios.get(API_URL, {
      params: cleanParams,
      ...AXIOS_CONFIG,
    });
    return response.data.content;
  } catch (error) {
    console.error("Error fetching analytics:", error);
    throw error;
  }
};
